import type { CareConnection } from "@src/packages/patients/hooks/useCareConnections";
import { MOCK_CYCLE_ID } from "@src/packages/cycles/dev/devActiveCycleOverride";

/**
 * Deterministic product-route fixture for visual evidence. It is opt-in via
 * `dev_care_connections=1` and never replaces API data in a normal build.
 */
export const DEV_CARE_CONNECTIONS: CareConnection[] = [
  {
    id: "81000000-0000-4000-8000-000000000001",
    patientId: "81000000-0000-4000-8000-000000000000",
    kind: "clinic",
    name: "Northstar Fertility",
    role: null,
    practiceName: "Northstar Fertility",
    location: "Boston, MA",
    contactEmail: "care@northstar.example",
    contactPhone: null,
    notes: null,
    specialty: null,
    addedVia: "manual",
    cycleIds: [],
    createdAt: "2026-07-10T10:00:00.000Z",
    updatedAt: "2026-07-11T10:00:00.000Z",
    updatedBy: null,
  },
  {
    id: "81000000-0000-4000-8000-000000000002",
    patientId: "81000000-0000-4000-8000-000000000000",
    kind: "pharmacy",
    name: "Alto Pharmacy",
    role: null,
    practiceName: "Alto Pharmacy",
    location: "United States",
    contactEmail: "care@alto.example",
    contactPhone: null,
    notes: null,
    specialty: null,
    addedVia: "manual",
    cycleIds: [],
    createdAt: "2026-07-09T10:00:00.000Z",
    updatedAt: "2026-07-12T10:00:00.000Z",
    updatedBy: null,
  },
  {
    id: "81000000-0000-4000-8000-000000000003",
    patientId: "81000000-0000-4000-8000-000000000000",
    kind: "provider",
    name: "Dr. Maya Chen",
    role: "REI",
    practiceName: "Harbor Women’s Health",
    location: "Boston, MA",
    contactEmail: "maya@harbor.example",
    contactPhone: null,
    notes: "Primary fertility specialist",
    specialty: "OB-GYN",
    addedVia: "manual",
    cycleIds: [],
    createdAt: "2026-07-08T10:00:00.000Z",
    updatedAt: "2026-07-08T10:00:00.000Z",
    updatedBy: null,
  },
  {
    id: "81000000-0000-4000-8000-000000000004",
    patientId: "81000000-0000-4000-8000-000000000000",
    kind: "provider",
    name: "Dr. Luis Ortiz",
    role: "Therapist",
    practiceName: "Harbor Care",
    location: "Boston, MA",
    contactEmail: null,
    contactPhone: null,
    notes: null,
    specialty: "Therapist",
    addedVia: "directory",
    cycleIds: [],
    createdAt: "2026-07-07T10:00:00.000Z",
    updatedAt: "2026-07-13T10:00:00.000Z",
    updatedBy: null,
  },
  {
    id: "81000000-0000-4000-8000-000000000005",
    patientId: "81000000-0000-4000-8000-000000000000",
    kind: "provider",
    name: "Nora Park, L.Ac.",
    role: "Acupuncturist",
    practiceName: null,
    location: null,
    contactEmail: null,
    contactPhone: null,
    notes: null,
    specialty: "Acupuncturist",
    addedVia: "manual",
    cycleIds: [],
    createdAt: "2026-07-06T10:00:00.000Z",
    updatedAt: "2026-07-14T10:00:00.000Z",
    updatedBy: null,
  },
];

export function getDevCareConnectionsOverride(): CareConnection[] | null {
  if (!__DEV__ || typeof window === "undefined") return null;
  const params = new URLSearchParams(window.location.search);
  if (params.get("dev_care_connections") !== "1") return null;
  if (params.get("dev_care_connections_cycle") !== "1") {
    return DEV_CARE_CONNECTIONS;
  }

  return DEV_CARE_CONNECTIONS.map((connection, index) =>
    index === 2
      ? {
          ...connection,
          addedVia: "cycle",
          cycleIds: [MOCK_CYCLE_ID],
        }
      : connection,
  );
}
